export default function removeSimulation() {
    if(document.querySelector(".simulation")) {
        let remove = document.querySelectorAll(".simulation .remove");
        let deleteItem = document.querySelector(".delete__yes");

        remove.forEach(currentRemove => {
            currentRemove.addEventListener("click", () => {
                let item = currentRemove.parentElement.parentElement;

                deleteItem.addEventListener("click", () => {
                    item.remove();
                });
            });
        });
    }
}
